export default __webpack_public_path__ + "static/media/logo.f97e8b09.svg";